var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 260,
    viewBox: "0 0 390 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 130H0V260H130V130Z",
    fill: "#4650EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 260L130 194.978H0L65 260Z",
    fill: "#FFEEF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 195.022L0 130H130L65 195.022Z",
    fill: "#FFEEF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H260V130H390V0Z",
    fill: "#FFEEF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M371.919 112.558H276.239V16.9541H371.919V112.558ZM291.286 97.5866H356.86V31.9258H291.297V97.5758L291.286 97.5866Z",
    fill: "#4650EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.787 48.2625H310.212V77.6966H339.787V48.2625Z",
    fill: "#4650EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260 126.286H130V256.286H260V126.286Z",
    fill: "#FFEEF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.065 256.285C159.163 256.285 130.043 227.263 130.043 191.448C165.956 191.448 195.065 220.47 195.065 256.285Z",
    fill: "#3340BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.957 256.285C230.869 256.285 259.978 227.263 259.978 191.448C224.066 191.448 194.957 220.47 194.957 256.285Z",
    fill: "#4650EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.065 191.22C159.163 191.22 130.043 162.198 130.043 126.383C165.956 126.383 195.065 155.416 195.065 191.22Z",
    fill: "#3340BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.957 191.22C230.869 191.22 259.978 162.198 259.978 126.383C224.066 126.383 194.957 155.416 194.957 191.22Z",
    fill: "#4650EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130 0H0V130H130V0Z",
    fill: "#4650EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 130H80.47C80.47 102.646 102.646 80.4702 130 80.4702V0.0327148H127.162C56.68 1.53855 0 59.1502 0 130Z",
    fill: "#FFEEF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260 0H130V130H260V0Z",
    fill: "#4650EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260 0C224.239 0.140833 195.292 29.185 195.292 65C195.292 100.815 224.239 129.859 260 130V0Z",
    fill: "#FFEEF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130 130C165.761 129.859 194.707 100.815 194.707 65C194.707 29.185 165.761 0.140833 130 0V130Z",
    fill: "#FFEEF0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M390 130H260V260H390V130Z",
    fill: "#FFEEF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M390 130C354.239 130.141 325.292 159.185 325.292 195C325.292 230.815 354.239 259.859 390 260V130Z",
    fill: "#4650EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260 260C295.761 259.859 324.707 230.815 324.707 195C324.707 159.185 295.761 130.141 260 130V260Z",
    fill: "#4650EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLoginBg);
export default __webpack_public_path__ + "static/media/Mob-Login-bg.5f77b17da1611fbdbc4f39ed3625b783.svg";
export { ForwardRef as ReactComponent };